import React from 'react';
import { Link } from 'react-router-dom';

export default function ServicesOverviewGrid({ className = '' }) {
  const services = [
    {
      title: 'Optagelsesvejledning',
      desc: 'Konkrete råd til lys, vinkler og rolig lyd, så I fremstår autentiske, indbydende og tillidsvækkende på video.',
      link: '/ydelser/online-vejledning',
      icon: (
        <svg className="w-5 h-5 text-sky-500 shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth="1.75" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z" />
        </svg>
      ),
    },
    {
      title: 'Klipning & Redigering',
      desc: 'Professionel videoredigering i 9:16 format med fængende hooks, undertekster og trending musik, der fastholder seerne.',
      link: '/ydelser/content-redigering',
      icon: (
        <svg className="w-5 h-5 text-sky-500 shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth="1.75" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="m7.848 8.25 1.536.887M7.848 8.25a3 3 0 1 1-5.196-3 3 3 0 0 1 5.196 3Zm1.536.887a2.165 2.165 0 0 1 1.083 1.846c.017.652-.332 1.281-.91 1.615l-.173.1M9.384 9.137l6.768 3.907m-6.768-3.907L16.5 4.5M3.75 20.25l7.008-4.046m0 0a2.25 2.25 0 1 0-2.25-3.897 2.25 2.25 0 0 0 2.25 3.897Zm0 0L19.5 20.25M7.848 15.75l1.536-.887m0 0a2.165 2.165 0 0 0 1.083-1.846c.017-.651-.332-1.28-.91-1.615l-.173-.1M9.384 14.863l6.768-3.907m0 0a3 3 0 1 1 5.196 3 3 3 0 0 1-5.196-3Z" />
        </svg>
      ),
    },
    {
      title: 'Idéer & Skudlister',
      desc: 'Konkrete skydelister og kreative emner tilpasset jeres branche, så I altid ved præcis, hvad I skal optage i hverdagen.',
      link: '/ydelser/online-vejledning',
      icon: (
        <svg className="w-5 h-5 text-sky-500 shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth="1.75" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 18v-5.25m0 0a6.01 6.01 0 0 0 1.5-.189m-1.5.189a6.01 6.01 0 0 1-1.5-.189m3.75 7.439v-2.25a2.25 2.25 0 0 0-2.25-2.25h-3a2.25 2.25 0 0 0-2.25 2.25v2.25m7.5 0H8.25m3.75-9a3.75 3.75 0 1 0-7.5 0 3.75 3.75 0 0 0 7.5 0Z" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364 1.386-1.591 1.591M21 12h-2.25m-1.386 6.364-1.591-1.591M3 12h2.25m1.386-6.364 1.591 1.591" />
        </svg>
      ),
    },
    {
      title: 'Meta SoMe Postkalender',
      desc: 'Oprettelse og løbende styring af jeres udgivelsesplan i Meta Business Suite, så I udkommer stabilt uden stress.',
      link: '/ydelser/meta-postkalender',
      icon: (
        <svg className="w-5 h-5 text-sky-500 shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth="1.75" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
        </svg>
      ),
    },
    {
      title: 'Opsætning & Profiloptimering',
      desc: 'Skarp bio, visuelle højdepunkter, links og opsætning på tværs af de kanaler og platforme, I ønsker at styrke.',
      link: '/ydelser/profil-opsaetning',
      icon: (
        <svg className="w-5 h-5 text-sky-500 shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth="1.75" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
        </svg>
      ),
    },
    {
      title: 'On-site optagelser efter aftale',
      desc: 'Udover jeres egne mobiloptagelser er vi fuldt fleksible til at komme ud og filme hos jeres forretning ved nærmere aftale.',
      link: '/kontakt',
      icon: (
        <svg className="w-5 h-5 text-sky-500 shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth="1.75" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
        </svg>
      ),
    },
    {
      title: 'Billed- & Stemningsindhold',
      desc: 'Vejledning og optimering af stemningsfotos, produkt- og atmosfærebilleder, der skaber lyst til at besøge jer.',
      link: '/ydelser/online-vejledning',
      icon: (
        <svg className="w-5 h-5 text-sky-500 shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth="1.75" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
        </svg>
      ),
    },
    {
      title: 'Fleksibel volumen & 0 binding',
      desc: 'Ingen rigide pakker eller lange bindinger – aftalen tilpasses dynamisk efter jeres sæsoner, kampagner og aktuelle behov.',
      link: '/saadan-arbejder-vi',
      icon: (
        <svg className="w-5 h-5 text-sky-500 shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth="1.75" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
        </svg>
      ),
    },
  ];

  return (
    <section className={`bg-[#0c1322] text-white py-16 sm:py-20 px-4 sm:px-6 lg:px-8 border-y border-slate-800/80 ${className}`}>
      <div className="max-w-7xl mx-auto space-y-10">
        {/* Header */}
        <div className="max-w-3xl space-y-3">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
            Vores brede vifte af ydelser omfatter bl.a.:
          </h2>
          <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
            Virksomheder har forskellige udgangspunkter – derfor kan I frit kombinere og tilpasse de services, der passer til netop jeres behov:
          </p>
        </div>

        {/* 4x2 Feature Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {services.map((item, idx) => (
            <Link
              key={idx}
              to={item.link}
              className="p-6 bg-[#0e172a] border border-slate-800 rounded-xl flex flex-col items-start gap-3 transition-all duration-200 hover:border-slate-700 hover:bg-[#131f38] group block text-left"
            >
              <div className="w-5 h-5 text-sky-500 group-hover:scale-110 transition-transform">
                {item.icon}
              </div>
              <div className="space-y-1.5 mt-1">
                <h3 className="text-[15px] font-semibold text-white group-hover:text-sky-400 transition-colors">
                  {item.title}
                </h3>
                <p className="text-[13px] text-slate-400 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </Link>
          ))}
        </div>

        {/* Footer Bar */}
        <div className="pt-6 border-t border-slate-800/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-2.5 text-sm text-slate-400">
            <svg className="w-4 h-4 text-sky-500 shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z" clipRule="evenodd" />
            </svg>
            <span>Ingen faste prispakker – aftaler tilpasses individuelt efter hvad jeres forretning har brug for.</span>
          </div>

          <Link
            to="/ydelser"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-sky-500 hover:text-sky-400 transition-colors group shrink-0"
          >
            <span>Se alle ydelser i detaljer</span>
            <span aria-hidden="true" className="group-hover:translate-x-1 transition-transform">&rarr;</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
